import * as Yup from 'yup';
import Translator from '../../core/i18n';

const T = Translator.create();

const RegExpDate = /^[0-9]{2}.[0-9]{2}.[0-9]{4}$/;

export function getValidation() {
return Yup.object().shape({
    firstName: Yup.string()
        .required(T.t('r_field_required')),
    lastName: Yup.string()
        .required(T.t('r_field_required')),
    email: Yup.string()
        .required(T.t('r_field_required'))
        .email(T.t('r_enter_valid_email_adress')),
    birthDateFormatted: Yup.string()
        .nullable()
        .matches(RegExpDate, T.t('r_date_format_incorrect_validation')),
    citizenshipIdentifier: Yup.number()
        .typeError(T.t('r_citizenshipIdentifier_number_error'))
        .nullable()
        .min(11, T.t('r_turkish_identity_number_length'))
  });
}